import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { encryptedKeyByAesKeyValidator, uuidValidator } from '#validation';
import { CommonMemberCryptoSchema } from '#web-service-api/member';
export const AcceptIndividualInvitationSchema = z.object({
    invitationId: uuidValidator({
        requiredError: 'invitation.id.required',
        formatError: 'invitation.id.uuid',
    }),
    ePrivateKeyByUserKey: encryptedKeyByAesKeyValidator,
    memberCrypto: CommonMemberCryptoSchema.optional(),
});
export class AcceptIndividualInvitationDto extends createZodDto(AcceptIndividualInvitationSchema) {
}
